<div class="branded-modal">
  <div class="branded-modal__container">
    <div class="gbm-plus-logo"></div>

    <div class="deposit-invitation">
      <div class="deposit-invitation__container">
        <div class="trading-logo"></div>

        <p>
          Registra la siguiente información en tu banca electrónica.
          <br />
          Ahora puedes hacer depósitos en cualquier momento y los verás
          reflejados en máximo 10 minutos
        </p>

        <div class="deposit-invitation__account-info">
          <div class="deposit-invitation__field">
            <div class="deposit-invitation__field-title">Banco</div>
            <div class="deposit-invitation__field-content">GBM</div>
          </div>

          <div class="deposit-invitation__field">
            <div class="deposit-invitation__field-title">CLABE</div>
            <div class="deposit-invitation__field-content" data-test-id="clabe">
              <ng-container *ngIf="clabe$ | async as clabe; else skeleton">
                {{ clabe | mask: '000 000 00000000000 0' }}
                <hb-copy-button
                  [copyContent]="clabe"
                  notificationContent="CLABE copiada al portapapeles"
                ></hb-copy-button>
              </ng-container>
            </div>
          </div>
        </div>

        <p>
          También puedes transferir saldo a tu estrategia desde Smart Cash o
          alguna otra estrategia
        </p>

        <button
          type="button"
          class="button button--small button--dark deposit-invitation__bottom-button"
          (click)="closeModal.next()"
        >
          Entendido
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #skeleton>
  <div class="deposit-invitation__field-content--skeleton skeleton"></div>
</ng-template>
